<template>
  <div class="growth-overview">
    <div class="growth-overview-container">
      <div class="growth-overview-title">成长概览</div>
      <div class="collapse-wrapper">
        <div class="collapse-item" v-for="(item1, index1) in initData" :key="index1">
          <div class="collapse-item__title-wrapper">
            <div class="icon-wrapper">
              <div class="icon-img">
                <img src="../assets/images/home/Department_Hit.png" alt="" />
              </div>
              <div class="fold-img" v-if="index1 == journeyData.length - 1 ? false : true" v-show="!item1.unFoldStatus">
                <img src="../assets/images/home/Department_arrow1.png" alt="" />
              </div>
            </div>
            <div class="title-wrapper">
              <div class="title">{{ item1 && item1.journeyName }}</div>
              <div class="sub-title">{{ item1 && item1.journeydescription }}</div>
            </div>
            <div class="fold-status-wrapper" @click="foldHandle(item1)">
              <div class="fold-status-text">
                {{ item1.unFoldStatus == true ? '收起' : '展开' }}
              </div>
              <div class="fold-status-icon" :class="item1.unFoldStatus ? 'rotateRight' : 'rotateLeft'">
                <img src="../assets/images/home/drop-down.png" alt="" />
              </div>
            </div>
          </div>
          <div class="collapse-item__content-wrapper" v-show="item1 && item1.unFoldStatus">
            <div class="progress-wrapper">
              <div class="progress-img" v-if="index1 == journeyData.length - 1 ? false : true" v-show="item1 && item1.unFoldStatus">
                <img src="../assets/images/home/Department_arrow2.png" alt="" />
              </div>
            </div>
            <div class="content-wrapper">
              <div class="doctor-item" v-for="(item2, index2) in item1.doctors" :key="index2" v-show="item1.doctors.length > 0" @click="goJourneyReport(item2)" :class="item2.refresher ? 'refresher' : ''">
              <!-- <div class="doctor-item" v-for="(item2, index2) in item1.doctors" :key="index2" v-show="item1.doctors.length > 0"  v-track="{functionName: item2.userName}" @click="goJourneyReport(item2)"> -->
                <div class="doctor-name">{{ item2 && item2.userName }}</div>
              </div>
              <div class="no-info" v-show="item1.doctors.length == 0">
                <div class="text">暂无...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'growth-overview',
  data() {
    return {
      journeyData: [
        {
          journeyName: '超声视界之旅',
          journeydescription: 'CDQI一级术者申报要求，近12个月房颤手术量：200',
          unFoldStatus: true,
          doctors: [
            {
              hcpName: '顾盼'
            },
            {
              hcpName: '王大力'
            }
          ]
        },
        {
          journeyName: '持续性房颤菁英之旅',
          journeydescription: 'CDQI二级术者申报要求，近12个月房颤：100',
          unFoldStatus: true,
          doctors: [
            {
              hcpName: '兰小颖'
            },
            {
              hcpName: '王迪'
            }
          ]
        },
        {
          journeyName: '阵发性房颤进阶之旅',
          journeydescription: 'CDQI三级术者申报要求，近12个月房颤：100',
          unFoldStatus: true,
          doctors: [
            {
              hcpName: '张军'
            },
            {
              hcpName: '赵阳'
            }
          ]
        },
        {
          journeyName: '电生理成长之旅',
          journeydescription: '成长所需，推荐手术量：30',
          unFoldStatus: true,
          doctors: [
            {
              hcpName: '李瞻仰'
            },
            {
              hcpName: '王明'
            }
          ]
        }
      ]
    }
  },
  props: {
    initData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    foldHandle(item) {
      item.unFoldStatus = !item.unFoldStatus
    },
    goJourneyReport(item) {
      let query = {
        multiCode: item.multiCode,
        doctorName: item.userName,
        source: 'growth-overview'
      }
      this.$router.push({
        path: '/journeyReport',
        query
      })
    }
  }
}
</script>

<style lang="less" scoped>
.growth-overview {
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f1f6;
  .growth-overview-container {
    width: 352px;
    background-color: #ffffff;
    border-radius: 12px;
    .growth-overview-title {
      width: 320px;
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      color: #000000;
      line-height: 17px;
      margin: 16px 0 11px 16px;
    }
    .collapse-wrapper {
      width: 344px;
      margin-left: 8px;
      .collapse-item {
        width: 344px;
        margin-top: 8px;
        .collapse-item__title-wrapper {
          width: 344px;
          height: 48px;
          display: flex;
          align-items: center;
          position: relative;
          background: #F9F8F7;
          border-radius: 2px;
          .icon-wrapper {
            width: 37px;
            height: 48px;
            position: relative;
            background-color: #ffffff;
            .icon-img {
              width: 24px;
              height: 24px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 9;
              img {
                width: 24px;
                height: 24px;
              }
            }
            .fold-img {
              width: 37px;
              height: 56px;
              position: absolute;
              top: 50%;
              left: 0;
              z-index: 9;
              img {
                width: 37px;
                height: 56px;
              }
            }
          }
          .title-wrapper {
            width: 250px;
            flex: 1;
            .title {
              width: 250px;
              height: 18px;
              font-size: 13px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 500;
              color: #2b2b2b;
              line-height: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .sub-title {
              width: 250px;
              height: 14px;
              font-size: 10px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #909091;
              line-height: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-top: 4px;
            }
          }
          .fold-status-wrapper {
            width: 50px;
            display: flex;
            align-items: center;
            .fold-status-text {
              width: 24px;
              height: 17px;
              font-size: 12px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #909091;
              line-height: 17px;
              margin-right: 3px;
            }
            .fold-status-icon {
              width: 11px;
              height: 17px;
              line-height: 17px;
              img {
                width: 11px;
                height: 7px;
              }
            }
          }
        }
        .collapse-item__content-wrapper {
          width: 344px;
          // min-height: 56px;
          position: relative;
          display: flex;
          align-items: center;
          .progress-wrapper {
            width: 37px;
            min-height: 56px;
            position: relative;
            .progress-img {
              width: 37px;
              height: 104px;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translate(0, -50%);
              z-index: 8;
              img {
                width: 37px;
                height: 104px;
              }
            }
          }
          .content-wrapper {
            width: 306px;
            flex: 1;
            min-height: 56px;
            display: flex;
            align-items: center;
            transition: height 0.5;
            flex-wrap: wrap;
            padding: 8px;
            .doctor-item {
              min-width: 55px;
              height: 24px;
              background: rgba(235, 23, 0, 0.05);
              border-radius: 12px;
              border: 0.5px solid rgb(235, 23, 0);
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              margin: 5px 4px;
              padding: 0 10px;
              .doctor-name {
                font-size: 12px;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                color: #EB1700;
                line-height: 17px;
              }
              &.refresher {
                border: 0.5px solid rgb(15, 104, 178);
                background: rgba(15, 104, 178, 0.05);
                .doctor-name {
                  color: #0F68B2;
                }
              }
            }
            // .doctor-item:nth-child(5n) {
            //   margin-right: 0;
            // }
            .no-info {
              width: 306px;
              height: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              .text {
                height: 14px;
                font-size: 10px;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                color: #d3d3d3;
                line-height: 14px;
              }
            }
          }
        }
      }
      .collapse-item:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
<style>
/* 收起动画 */
.fold {
  animation: fold 0.5s linear both;
}
.unFold {
  animation: unFold 0.5s linear both;
}
.rotateRight {
  animation: rotateRight 0.25s linear both;
}
.rotateLeft {
  animation: rotateLeft 0.25s linear both;
}
@keyframes fold {
  0% {
    height: 56px;
  }
  100% {
    height: 0;
  }
}
/* 展开动画 */
@keyframes unFold {
  0% {
    height: 0%;
  }
  100% {
    height: 56px;
  }
}
@keyframes rotateRight {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes rotateLeft {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GrowthOverview.vue